class VideoModal {
    constructor() {
        this.modal = document.getElementById('videoModal');
        this.triggers = document.querySelectorAll('.js-video-modal-trigger');
        this.closeBtn = this.modal.querySelector('.video-modal__close');
        this.overlay = this.modal.querySelector('.video-modal__overlay');
        this.iframe = document.getElementById('videoIframe');
        
        this.init();
    }

    init() {
        // Add click events to all trigger buttons
        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                const videoUrl = trigger.href;
                const videoId = this.getYoutubeId(videoUrl);
                if (videoId) {
                    this.openModal(videoId);
                }
            });
        });

        // Close button event
        this.closeBtn.addEventListener('click', () => this.closeModal());
        
        // Overlay click event
        this.overlay.addEventListener('click', () => this.closeModal());
        
        // Escape key event
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
                this.closeModal();
            }
        });
    }

    getYoutubeId(url) {
        console.log('Processing URL:', url); // Debug log
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        console.log('Match result:', match); // Debug log
        return (match && match[2].length === 11) ? match[2] : null;
    }

    openModal(videoId) {
        console.log('Opening modal with video ID:', videoId); // Debug log
        this.iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        this.modal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
    }

    closeModal() {
        this.modal.classList.remove('is-active');
        this.iframe.src = '';
        document.body.style.overflow = '';
    }
}

// Initialize the video modal
document.addEventListener('DOMContentLoaded', () => {
    console.log('Initializing video modal'); // Debug log
    new VideoModal();
});